import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import PayoutList from "./PayoutList";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import Notification from "../../elements/notification/Notification";
import { AppContext } from "../../../App";

import MaterialPagination from "../../styles/materialPagination";
import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledPayoutWrapper } from "../styledPayout";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import TransactionFilter from "../../elements/transactions/TransactionFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import { PAYMENT_SYSTEM, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { parseAxiosError } from "../../../utils/response";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";
import { useTranslation } from "react-i18next";

const PayoutContainer = () => {
  const { t } = useTranslation("payoutsPage");
  const [payouts, setPayouts] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const { user } = useContext(AppContext);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "createdAt[gte]": checkFilterItem(history, "createdAt[gte]", null, true),
    "createdAt[lte]": checkFilterItem(history, "createdAt[lte]", null, true),
    "status.value": checkFilterItem(history, "status.value", null),
    "id": checkFilterItem(history, "id", null),
    "referenceId": checkFilterItem(history, "referenceId", null),
    "processingId": checkFilterItem(history, "processingId", null),
    "exchangeId": checkFilterItem(history, "exchangeId", null),
    "hash": checkFilterItem(history, "hash", null),
    "note": checkFilterItem(history, "note", null),
    "resourceType": checkFilterItem(history, "resourceType", null),
    "processedAmount[gte]": checkFilterItem(history, "processedAmount[gte]", null, true),
    "processedAmount[lte]": checkFilterItem(history, "processedAmount[lte]", null, true),
    "currency.asset": checkFilterItem(history, "currency.asset", null),
    "connection.service.name": checkFilterItem(history, "connection.service.name", null),
    "connection.project.name": checkFilterItem(history, "connection.project.name", null),
    "paymentType": checkFilterItem(history, "paymentType", null),
    "transactionType": checkFilterItem(history, "transactionType", null),
    "relatedReferenceId": checkFilterItem(history, "relatedReferenceId", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchPayouts = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/get-transaction-native" + filterUrl + '&resourceType=payout' + "&paymentSystem.name=" + PAYMENT_SYSTEM.BALANCE_REFILING,
      userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setPayouts(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };


  // TODO add pusher
  const updateTransaction = (message) => {
    const data = JSON.parse(message.data);
    const index = payouts.findIndex(p => p.id === data.id);
    if (index >= 0) {
      payouts[index].processedAmount = data.processedAmount;
      payouts[index].status = data.status;
      let newArr = [];
      setPayouts([
        ...payouts,
        ...newArr
      ]);
    }
  };

  useEffect(() => {
    fetchPayouts();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledPayoutWrapper>
          <div className="payouts-head">
            <TransactionFilter
              filterData={filterData}
              setFilterData={setFilterData}
              direction="payouts"
            />
            <ItemsPerPageSelect
              itemsPerPage={filterData.itemsPerPage}
              setItemsPerPage={(data) => setFilterData({
                ...filterData,
                "itemsPerPage": data,
                page: 1
              })}
            />
          </div>
          <FilterAppliedList
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <PayoutList payouts={payouts} />
          {totalPageCount > 1  &&
            <MaterialPagination
              count={totalPageCount}
              shape="rounded"
              page={filterData.page}
              onChange={(event, page) => onChangePage(event, page)}
            />}
        </StyledPayoutWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default PayoutContainer;